import React from "react";
import { Toast, Button, List, InputItem, Modal } from "antd-mobile";
import { post } from "../../utils/request.js";
import { href, viewPort } from "../../utils/util.js";

import api from "./api.js";

import "./index.less";
class vehicleInquiryInputPage extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      urlOps: {},
      modalType: false,
      selectType: false,
      vCode: false,
      second: 60,
      carPlateNumber: "",
      phoneNumber: "",
      imageCode: "",
      contactName: "",
      imgUrl: "",
      agreementUrl: "",
      serviceAgreenmentType: false,
      recordCode: "",
      dialogShow: false,
      errorMessage: "",
    };
  }

  // #/vehicleInquiryInputPage?name=xxxx&inviteCode=xxx
  componentDidMount() {
    var obj = "",
      obj1 = "",
      ops = {};
    if (window.location.hash.indexOf("?") > -1) {
      obj = decodeURIComponent(window.location.hash).split("?")[1];
      obj1 = obj.split("&");
      for (var i = 0; i < obj1.length; i++) {
        ops[obj1[i].split("=")[0]] =
          obj1[i].split("=")[1] === "undefined" ? "" : obj1[i].split("=")[1];
      }
      this.setState({
        phoneNumber: ops.phoneNumber,
        carPlateNumber: ops.carPlateNumber,
        contactName: ops.contactName,
        urlOps: ops,
      });
    }
  }

  // 询价
  submit() {
    const { urlOps, phoneNumber, contactName, carPlateNumber } = this.state;
    const viewPortData = viewPort();
    let app_stoken = "";
    if (viewPortData.ios || viewPortData.iPhone || viewPortData.iPad) {
      if (window.webkit) {
        app_stoken = window.prompt("getAppToken", "");
      }
    } else {
      if (window.huilian && window.huilian.getAppToken) {
        app_stoken = window.huilian.getAppToken();
      }
    }
    post({
      url: api.addCarInsuranceInquiry + "?app_stoken=" + app_stoken,
      data: {
        contactPhone: phoneNumber,
        contactName,
        carPlateNumber,
      },
    }).then(
      (res) => {
        if (res.result === "success") {
          href(`/vehicleInquirySuccess`);
        } else {
          // this.setState({
          //   dialogShow: true,
          //   errorMessage: res.message || "询价失败",
          // });
        }
      },
      (res) => {
        // Toast.info("询价失败", 1);
      }
    );
    // this.viewPort();
  }
  // viewPort =  () => {
  //     let device_type = navigator.userAgent.toLowerCase();
  //     console.log(device_type);
  // }

  render() {
    const {
      selectType,
      phoneNumber,
      carPlateNumber,
      contactName,
      serviceAgreenmentType,
      agreementUrl,
      errorMessage,
      dialogShow,
    } = this.state;
    // console.log(urlOps)
    return (
      <div className="vehicleInquiryInputPageBox">
        <div className="registerBox">
          <div className="inputBox">
            <List style={{ marginBottom: "0.23rem" }}>
              <InputItem
                type="money"
                value={carPlateNumber}
                moneyKeyboardAlign="right"
                editable={false}
              >
                车牌号
              </InputItem>
              <InputItem
                type="text"
                moneyKeyboardAlign="right"
                placeholder="请填写联系人姓名"
                value={contactName}
                maxLength={15}
                onChange={(val) => {
                  this.setState({
                    contactName: val,
                  });
                }}
              >
                联系人
              </InputItem>
              <InputItem
                className="phoneNumber"
                type="text"
                moneyKeyboardAlign="left"
                value={phoneNumber}
                editable={false}
                extra={
                  <a
                    onClick={() => {
                      let url = encodeURI(
                        "/vehicleInquiryChange?phoneNumber=" +
                          phoneNumber +
                          "&carPlateNumber=" +
                          carPlateNumber +
                          "&contactName=" +
                          contactName
                      );
                      href(url);
                    }}
                  >
                    更换
                  </a>
                }
                onChange={() => {}}
              >
                手机号
              </InputItem>
            </List>
          </div>
        </div>
        <div className="isAgreementBox">
          <div
            className={"radio " + (selectType ? "active" : "")}
            onClick={() => {
              this.setState({
                selectType: !selectType,
              });
            }}
          >
            <i></i>
            <span>我已阅读并同意</span>
          </div>
          <div>
            <a
              onClick={() => {
                href("/vehicleInquiryRule");
              }}
            >
              《服务使用协议》
            </a>
          </div>
        </div>
        <div
          className="reward_3_row"
          onClick={() => {
            if (contactName.length === 0) {
              Toast.info("请填写联系人！", 1);
              return;
            }
            if (!phoneNumber || phoneNumber.length < 11) {
              Toast.info("手机号码不正确", 1);
              return;
            }
            if (!selectType) {
              Toast.info("请同意并勾选《服务使用协议》", 1);
              return;
            }
            this.submit();
          }}
        >
          立即询价
        </div>

        {serviceAgreenmentType ? (
          <div className="serviceAgreenmentBox">
            <div>
              <div className="iframe">
                <iframe src={agreementUrl}></iframe>
              </div>
              <Button
                type="primary"
                onClick={() => {
                  this.setState({
                    serviceAgreenmentType: false,
                  });
                }}
              >
                确认
              </Button>
            </div>
          </div>
        ) : (
          ""
        )}
        <Modal
          visible={dialogShow}
          transparent
          maskClosable={false}
          title=""
          footer={[
            {
              text: "知道了",
              onPress: () => {
                this.setState({
                  dialogShow: false,
                });
              },
            },
          ]}
        >
          <div>{errorMessage}</div>
        </Modal>
      </div>
    );
  }
}

export default vehicleInquiryInputPage;



// WEBPACK FOOTER //
// ./src/vehicleInquiry/inputPage/index.js